import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=38fb2864&scoped=true"
import script from "./AssetList.vue?vue&type=script&lang=js"
export * from "./AssetList.vue?vue&type=script&lang=js"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=38fb2864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb2864",
  null
  
)

export default component.exports